'use client';

import { ReactElement } from 'react';

import { CustomButtonLink } from '@/components/CustomButton';
import PATHS from '@/constants/paths';

interface IHeaderViewAllButtonProps {
	text?: string;
	loading?: boolean;
	className?: string;
	isShallow?: boolean;
}

const HeaderViewAllButton = ({
	className,
	loading = false,
	isShallow = false,
	text = 'View all networks',
}: IHeaderViewAllButtonProps): ReactElement => (
	<CustomButtonLink
		loading={loading}
		shallow={isShallow}
		href={PATHS.NETWORKS.ROOT('mainnet')}
		className={`min-w-max bg-violet text-base font-medium capitalize text-white hover:bg-white-hover hover:text-midnight ${
			loading ? 'pointer-events-none !flex cursor-default flex-row gap-2' : ''
		} ${className}`}>
		<span>{text}</span>
	</CustomButtonLink>
);

export default HeaderViewAllButton;
